import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-c7-seven-one-three',
  templateUrl: './c7-seven-one-three.component.html',
  styleUrls: ['./c7-seven-one-three.component.scss']
})
export class C7SevenOneThreeComponent implements OnInit {
pdfSrc: string[] = ['/assets/pdf/NAAC/Criterion-7/7.1.1/7.1.3_Environment and Green  Internal Audit report.pdf'];
  src: string;
  constructor() { }

  ngOnInit(): void {
    this.src = this.pdfSrc[0];
  }

}
